import { createAction } from 'redux-actions'

const ENTITY = 'MODAL'
export const stateKey = ENTITY.toLowerCase()

export const showModal = createAction(`${ENTITY}/SHOW`)
export const hideModal = createAction(`${ENTITY}/HIDE`)
export const updateModal = createAction(`${ENTITY}/UPDATE_PROPS`)
